import styled, { keyframes } from 'styled-components';
export const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateX(50px); }
  10% { opacity: 1; transform: translateX(0); }
  90% { opacity: 1; transform: translateX(0); }
  100% { opacity: 0; transform: translateX(-50px); }
`;
export const MessageContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  text-align: center;
  font-size: 1.6rem;
  overflow: hidden;
  height: 50px;
`;
export const Message = styled.div`
  position: absolute;
  width: 100%;
  animation: ${fadeInOut} 4s linear infinite;
`;